export enum PermEnum {
  All = 'all',
  InformalReflection = 'informal_reflection',
  FormalStudent = 'formal_student',
  FormalTeacher = 'formal_teacher',
  Activity = 'activity',
  Paper = 'paper',
  System = 'system',
  Gateway = 'gateway',
  Information = 'information',
}
